var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"course-card",style:(_vm.backgroundStyle),attrs:{"to":("/categories/" + (_vm.category.id) + "/courses/" + (_vm.course.id))}},[_c('h3',{staticClass:"course-card__heading"},[_vm._v(_vm._s(_vm.course.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }